import React from 'react';
import SuccessModal from './SuccessModal';
import ModalWithEmail from './ModalWithEmail';
import TextOnlyModal from './TextOnlyModal';
import { ProspectiveCustomerStore } from '../../utils/ols-core';
import PropTypes from 'prop-types';
import { assign } from 'lodash';
import * as Metrics from '../utils/trackMetric';
import * as MetricEvents from '../../../constants/metrics';
import { mapContextToProps } from '../OlsShopContext';

export class ComingSoonModal extends React.Component {
  constructor() {
    super(...arguments);

    this.state = assign(this.getStoreState());
  }

  getStoreState = () => {
    return {
      fetched: ProspectiveCustomerStore.getState().fetched
    };
  };

  componentDidMount() {
    Metrics.track(MetricEvents.COMING_SOON_MODAL_IMPRESSION);
  }

  UNSAFE_componentWillMount() {
    ProspectiveCustomerStore.addListener('change', this.onStoreChange);
  }

  onStoreChange = () => {
    this.setState(this.getStoreState());
  };

  closeModalWrapper = e => {
    e.preventDefault();

    ProspectiveCustomerStore.setState({
      email: '',
      fetched: false,
      fetching: false,
      genericError: null,
      invalidEmailError: null
    });

    return this.props.closeModal();
  };

  get modalProps() {
    return {
      renderMode: this.props.renderMode,
      closeModal: this.closeModalWrapper
    };
  }

  get modalComponent() {
    const {
      featureFlags: { textOnlyProspectiveModal = false }
    } = this.props;

    let component = ModalWithEmail;
    if (this.state.fetched) {
      component = SuccessModal;
    } else if (textOnlyProspectiveModal) {
      component = TextOnlyModal;
    }

    return component;
  }

  render() {
    return <this.modalComponent { ...this.modalProps } />;
  }
}

ComingSoonModal.propTypes = {
  renderMode: PropTypes.string,
  closeModal: PropTypes.func,
  featureFlags: PropTypes.object
};

ComingSoonModal.defaultProps = {
  featureFlags: {}
};

export default mapContextToProps(ComingSoonModal, context => ({
  featureFlags: context.featureFlags
}));
